import { render, staticRenderFns } from "./ImageTemplateIndex.vue?vue&type=template&id=10523e4c&scoped=true&"
import script from "./ImageTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./ImageTemplateIndex.vue?vue&type=script&lang=js&"
import style0 from "./ImageTemplateIndex.vue?vue&type=style&index=0&id=10523e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10523e4c",
  null
  
)

export default component.exports